import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass]
})
export class ModalComponent implements OnInit {
    constructor(private renderer: Renderer2) { }

    @Input() dialogClass: string;
    @Input() postition = 'top';
    @Input() autofocus: HTMLElement | string;
    @Output() hidden = new EventEmitter<any>();
    @Output() shown = new EventEmitter();
    @ViewChild('modal', { static: true }) modalElemRef: ElementRef;
    focusTarget: ElementRef;
    result: any;
    mandatory = false;
    isOpen = false;
    #modal: any;

    ngOnInit() {
        this.renderer.listen(this.modalElemRef.nativeElement, 'hidden.bs.modal', () => this.onHidden());
        this.renderer.listen(this.modalElemRef.nativeElement, 'shown.bs.modal', () => this.onShown());
    }

    onHidden() {
        this.isOpen = false;
        this.hidden.emit(this.result);
        this.result = null;
        if (this.focusTarget) {
            this.focusTarget.nativeElement.focus();
        }
    }

    onShown() {
        this.isOpen = true;
        if (this.autofocus && typeof this.autofocus === 'string') {
            const elem = document.querySelector(this.autofocus);
            if (elem) {
                (elem as HTMLElement)?.focus();
            }
        } else if (this.autofocus && typeof this.autofocus !== 'string') {
            this.autofocus.focus();
        }

        this.shown.emit();
    }

    cancel() {
        this.hide(null);
    }

    hide(result?: any) {
        this.result = result;

        if (this.#modal) {
            this.#modal.hide();
        } else {
            this.onHidden();
        }
    }

    show(focusTarget?: ElementRef, mandatory?: boolean) {
        if (focusTarget) {
            this.focusTarget = focusTarget;
        }

        this.mandatory = mandatory || false;

        const options = {
            show: true,
            backdrop: mandatory ? 'static' : true,
            keyboard: !mandatory
        };

        this.#modal = new (window as any).bootstrap.Modal(this.modalElemRef.nativeElement, options);
        this.#modal.show();
    }
}
